import { InterceptDialog } from "@hellocarbo/lasagne";
import { ComponentProps, use } from "react";

import { PortalContainerContext } from "@/contexts";

type UpsellModalProps = Omit<
  ComponentProps<typeof InterceptDialog>,
  "portalContainer"
>;

const UpsellModal = ({ children, ...props }: UpsellModalProps) => {
  const { container } = use(PortalContainerContext);

  return (
    <InterceptDialog {...props} portalContainer={container as Element}>
      {children}
    </InterceptDialog>
  );
};

export default UpsellModal;
